export function animate() {
	var controller = new ScrollMagic.Controller();

	function pathPrepare($el) {
		let lineLength = $el[0].getTotalLength();
		$el.css("stroke-dasharray", lineLength);
		$el.css("stroke-dashoffset", lineLength);
	}

	let $route      = $("path#line1");
	let $final      = $('path#line2');

	// prepare SVG

	if($route.length) {
		pathPrepare($route);
	}

	if($final.length) {
		pathPrepare($final);
	}

	// build tween
	let route_1 = new TimelineMax()
		.add(TweenMax.to($route, 0.4, {
			strokeDashoffset: 0,
			ease: Linear.easeNone
		}));

	let route_2 = new TimelineMax()
		.add(TweenMax.to($final, 0.5, {
			strokeDashoffset: 0,
			ease: Linear.easeNone
		}));

	let scene = new ScrollMagic.Scene({
		triggerElement: "#trigger-route-1",
		duration: 1800,
		tweenChanges: true
	})
		.setTween(route_1)
		//.addIndicators()
		.addTo(controller);

	let scene2 = new ScrollMagic.Scene({
		triggerElement: "#trigger-route-2",
		duration: 400,
		tweenChanges: true
	})
		.setTween(route_2)
		//.addIndicators()
		.addTo(controller);

	return 'animate';
}